var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table-log" },
    [
      _vm.getImportsList.length === 0
        ? _c("CompassAlert", {
            staticClass: "table-log__alert",
            attrs: {
              type: "neutral",
              description: _vm.$t.__("common.labels.no_import_maded"),
              "show-close": false
            }
          })
        : _c("div", [
            _c(
              "table",
              { ref: "importLogs", staticClass: "table-log__table" },
              [
                _c("thead", [
                  _c(
                    "tr",
                    _vm._l(_vm.columns, function(col, index) {
                      return _c(
                        "th",
                        {
                          key: index,
                          staticClass: "typographies-paragraph-medium-bold",
                          class: col.class
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(col.label) +
                              "\n                    "
                          )
                        ]
                      )
                    }),
                    0
                  )
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  {
                    ref: "tableLogContent",
                    on: { scroll: _vm.onTableContentScroll }
                  },
                  [
                    _vm._l(_vm.getImportsList, function(log, index) {
                      return _c(
                        "tr",
                        {
                          key: log.id,
                          ref: "tableTrItem" + index,
                          refInFor: true
                        },
                        [
                          _c("td", { staticClass: "table-log__date" }, [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "typographies-paragraph-medium-regular"
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.getDateFormatted(
                                        log.created_at,
                                        "DD/MM/YYYY"
                                      )
                                    ) +
                                    "\n                        "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass:
                                  "table-log__minor-date typographies-paragraph-small-regular"
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.getDateFormatted(
                                        log.created_at,
                                        "HH:mm"
                                      )
                                    ) +
                                    "\n                        "
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticClass:
                                "table-log__type typographies-paragraph-medium-regular"
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.getTypeOfImport(log.type)) +
                                  "\n                    "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticClass:
                                "table-log__status typographies-paragraph-medium-regular"
                            },
                            [
                              _c("ImportTag", {
                                attrs: {
                                  label: _vm.getImportStatus(log),
                                  status: log.status
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticClass:
                                "table-log__user typographies-paragraph-medium-regular"
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.getFullNameStaff(log)) +
                                  "\n                    "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticClass:
                                "table-log__processed typographies-paragraph-medium-regular"
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.getLabelForLine(
                                        log,
                                        log.processed_rows,
                                        "log"
                                      )
                                    ) +
                                    "\n                        "
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticClass:
                                "table-log__invalid typographies-paragraph-medium-regular"
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.getLabelForLine(
                                        log,
                                        log.invalid_rows,
                                        "log"
                                      )
                                    ) +
                                    "\n                        "
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticClass:
                                "table-log__action typographies-paragraph-small-semibold"
                            },
                            [
                              _c(
                                "div",
                                [
                                  _c(
                                    "CompassTooltip",
                                    {
                                      attrs: {
                                        "content-class":
                                          "tooltip-settings-import",
                                        disabled: _vm.isImportCanBeReverted(
                                          log
                                        ),
                                        delay: { show: 500, hide: 0 },
                                        content: _vm.getRevertImportBtnLabel(
                                          log
                                        )
                                      }
                                    },
                                    [
                                      log.is_revertible &&
                                      log.processed_rows > 0
                                        ? _c("CompassButton", {
                                            ref: "cancelImportBtn",
                                            refInFor: true,
                                            attrs: {
                                              label: _vm.$t.__(
                                                "common.actions.cancel"
                                              ),
                                              type: "tertiary-destructive",
                                              disabled: !_vm.isImportCanBeReverted(
                                                log
                                              ),
                                              size: "small"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.onRevert(log)
                                              }
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.isImportCancellable(log)
                                    ? _c("CompassButton", {
                                        attrs: {
                                          type: "tertiary-destructive",
                                          size: "small",
                                          label: _vm.$t.__(
                                            "common.actions.cancel"
                                          )
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.onCancel(log)
                                          }
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("CompassButton", {
                                    attrs: {
                                      label: _vm.$t.__(
                                        "settings.import.ImportLogs.see"
                                      ),
                                      type: "secondary",
                                      size: "small"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.onDisplayDetail(log.id)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _vm.isLoadingMoreNeeded
                      ? _c("tr", { staticClass: "table-log__loader" }, [
                          _c(
                            "td",
                            { attrs: { colspan: "7" } },
                            [
                              _c("CompassLoader", {
                                attrs: { color: "common-icon-neutral" }
                              })
                            ],
                            1
                          )
                        ])
                      : _vm._e()
                  ],
                  2
                )
              ]
            )
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }